import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import IconButton from "material-ui/IconButton";
import Menu, { MenuItem } from "material-ui/Menu";
import MoreVertIcon from "material-ui-icons/MoreVert";
import validate from "validate.js";
import constants from "constants";
import { sortExpertsByNumeration } from "utils/sort-experts";

const { CPD_STATUSES } = constants;

// function WebinarItem({
class WebinarItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  render() {
    const {
      id,
      webinar_title,
      start_date,
      end_date,
      sponsor,
      sponsors,
      cpd_points,
      status,
      cpd_quiz,
      int_cpd_points,
      ext_cpd_points,
      cpd_status,
      experts,
      feedback_form_id,
    } = this.props.webinar;

    const showCertificatesLink =
      status === "published" && cpd_status === "granted";

    const sponsorTitles = sponsors.length
      ? sponsors.map((_sponsor) => _sponsor.title || "N/A")
      : [(sponsor && sponsor.title) || "N/A"];
    const sponsorTitlesAsString = sponsorTitles.join(", ");

    const is_checked = _.includes(this.props.webinar_ids, id);
    const ITEM_HEIGHT = 48;
    const { anchorEl } = this.state;
    return (
      <tr>
        <td>
          {!(
            new Date(start_date) <= new Date() &&
            new Date(end_date) >= new Date()
          ) && (
            <p>
              <input
                type="checkbox"
                className="filled-in"
                id="filled-in-box10"
                checked={is_checked}
                key={id}
              />
              <label
                for="filled-in-box10"
                onClick={() => this.props.checkedWebinarIds(id)}
              ></label>
            </p>
          )}
        </td>
        <td>
          {start_date ? moment(start_date).format("D/M/YYYY") : "Record"}
          <span>
            {start_date
              ? moment(start_date).format("h:mm a").toUpperCase()
              : ""}
          </span>
        </td>
        <td>{webinar_title}</td>
        <td>
          {experts
            ? sortExpertsByNumeration(experts).map((expert, index) => (
                <p key={index}>
                  {expert.name && expert.name != null ? expert.name : ""}
                </p>
              ))
            : ""}
        </td>
        {cpd_status === CPD_STATUSES.granted && (
          <td>
            {(cpd_points == "internal" || cpd_points == "both") &&
              `${int_cpd_points} Int`}
            {cpd_points == "both" && ", "}
            {(cpd_points == "external" || cpd_points == "both") &&
              `${ext_cpd_points} Ext`}
          </td>
        )}
        {cpd_status !== CPD_STATUSES.granted && (
          <td>{validate.prettify(cpd_status)}</td>
        )}
        <td>{cpd_points}</td>
        <td>{cpd_quiz}</td>
        <td>{sponsorTitlesAsString}</td>
        <td>{status}</td>
        <td>
          <IconButton
            className="table_more"
            aria-label="More"
            aria-owns={anchorEl ? "long-menu" : null}
            aria-haspopup="true"
            onClick={this.handleClick}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="long-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: 200,
              },
            }}
          >
            <MenuItem onClick={() => this.props.navigateToWebinar(id)}>
              Edit
            </MenuItem>
            {this.props.role === "admin" && (
              <MenuItem
                onClick={() => this.props.navigateToWebinarsUsersNewsletter(id)}
              >
                Newsletter users
              </MenuItem>
            )}
            <MenuItem
              onClick={() =>
                this.props.navigateToFeedbackEdit(feedback_form_id)
              }
            >
              Edit Feedback Form
            </MenuItem>
            <MenuItem
              onClick={() => {
                this.props.showQuestions(id);
                this.handleClose();
              }}
            >
              Questions
            </MenuItem>
            {this.props.role === "admin" && (
              <MenuItem onClick={() => this.props.navigateToWebinarsUsers(id)}>
                Registered users
              </MenuItem>
            )}
            {this.props.role === "admin" && (
              <MenuItem
                onClick={() => this.props.navigateToWebinarsUsersSession(id)}
              >
                Registered user sessions
              </MenuItem>
            )}
            {this.props.role === "admin" && showCertificatesLink && (
              <MenuItem onClick={() => this.props.navigateToCertificates(id)}>
                Add certificates
              </MenuItem>
            )}
          </Menu>
        </td>
      </tr>
    );
  }
}

WebinarItem.defaultProps = {};

WebinarItem.propTypes = {};

export default WebinarItem;



// WEBPACK FOOTER //
// ./src/components/Admin/Webinar/List/WebinarItem.jsx